import {createStore} from 'vuex';

let cachedUsername = null;
try { cachedUsername = localStorage.getItem('um_username'); } catch (e) {}

export default createStore({
    state: {
        user: undefined,
        myBundle: sessionStorage.getItem('myBundle') === 'true',
        username: cachedUsername,
        stars: 0,
        plays: 0,
        crateProgress: 0,
        pendingCrates: [],
        streakCount: 0,
        lastPlayedDate: null,
        isVip: false,
        subscriptionStatus: null,
        showPlaysFinishedPopup: false,
        showOutOfPlaysPopup: false,
        showPrizeInformation: false,
        showClaimPrizes: false,
        showMonthlyDraw: false,
        broadcastedGameState: undefined,
        isLoading: false,
        lastGameId: null,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setMyBundle(state, myBundle) {
            state.myBundle = myBundle;
            sessionStorage.setItem('myBundle', myBundle ? 'true' : 'false');
        },
        setUsername(state, username) {
            let cached = null;
            try { cached = localStorage.getItem('um_username'); } catch (e) {}
            state.username = cached || username;
        },
        setStars(state, stars) {
            state.stars = Math.max(0, Number(stars) || 0);
        },
        setPlays(state, plays) {
            state.plays = Math.max(0, Number(plays) || 0);
        },
        setCrateProgress(state, crateProgress) {
            state.crateProgress = crateProgress;
        },
        setPendingCrates(state, pendingCrates) {
            state.pendingCrates = pendingCrates;
        },
        setStreakCount(state, streakCount) {
            state.streakCount = streakCount;
        },
        setLastPlayedDate(state, lastPlayedDate) {
            state.lastPlayedDate = lastPlayedDate;
        },
        setIsVip(state, isVip) {
            state.isVip = isVip;
        },
        setSubscriptionStatus(state, subscriptionStatus) {
            state.subscriptionStatus = subscriptionStatus;
        },
        setShowPlaysFinishedPopup(state, value) {
            state.showPlaysFinishedPopup = value;
        },
        setShowOutOfPlaysPopup(state, value) {
            state.showOutOfPlaysPopup = value;
        },
        setShowPrizeInformation(state, value) {
            state.showPrizeInformation = value;
        },
        setShowClaimPrizes(state, value) {
            state.showClaimPrizes = value;
        },
        setShowMonthlyDraw(state, value) {
            state.showMonthlyDraw = value;
        },
        setBroadcastedGameState(state, broadcastedGameState) {
            state.broadcastedGameState = broadcastedGameState;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setLastGameId(state, lastGameId) {
            state.lastGameId = lastGameId;
        },
    },
    getters: {
        // True if the user already has a username from ANY source — the dedicated field,
        // or the username on the getUser record. Both casings: our SDP row is PascalCase
        // (Username); lowercase only existed while get-user merged DEP's payload in.
        // Used to skip the CreateUsername step for existing users.
        hasUsername(state) {
            const nested = state.user && state.user.user;
            const u = state.username
                || (nested && (nested.username ?? nested.Username))
                || (state.user && (state.user.username ?? state.user.Username));
            return typeof u === 'string' && u.trim().length > 0;
        },
    },
    actions: {},
    modules: {}
})
